import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";

export default function TermsGate() {
  const { user, needsTerms, setNeedsTerms, termsInfo } = useAuth();
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setChecked(false);
  }, [needsTerms]);

  if (!user || !needsTerms) return null;

  const accept = async () => {
    if (!checked) return;
    setSaving(true);
    try {
      await api.post("/terms/accept", {
        terms_version: termsInfo.terms_version,
        privacy_version: termsInfo.privacy_version,
      });
      setNeedsTerms(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-[#081F5C] flex items-center justify-center p-6" data-testid="terms-gate">
      <div className="w-full max-w-md bg-[#0D2875] border border-[#EDE0CC]/20 rounded-3xl p-6 shadow-2xl">
        <h2 className="text-xl font-semibold text-[#EDE0CC]">Welcome to <Wordmark /></h2>
        <p className="mt-3 text-sm text-[#EDE0CC]/80 leading-relaxed">
          Before you start brewing, please review and accept our Terms & Conditions and Privacy Policy.
        </p>
        <div className="mt-4 flex gap-3 text-sm">
          <Link to="/terms" className="underline text-[#EDE0CC]" data-testid="terms-gate-terms-link">Terms & Conditions</Link>
          <Link to="/privacy" className="underline text-[#EDE0CC]" data-testid="terms-gate-privacy-link">Privacy Policy</Link>
        </div>
        <label className="mt-5 flex items-start gap-3 cursor-pointer">
          <Checkbox checked={checked} onCheckedChange={(v) => setChecked(!!v)} data-testid="terms-gate-checkbox" className="mt-0.5 border-[#EDE0CC]/50 data-[state=checked]:bg-[#EDE0CC] data-[state=checked]:text-[#081F5C]" />
          <span className="text-sm text-[#EDE0CC]/90">I accept the Terms & Conditions and Privacy Policy.</span>
        </label>
        <Button
          onClick={accept}
          disabled={!checked || saving}
          data-testid="terms-gate-accept-btn"
          className="mt-6 w-full h-12 rounded-full bg-[#EDE0CC] text-[#081F5C] font-semibold hover:bg-[#E5D3B8] disabled:opacity-40"
        >
          {saving ? "Saving…" : "Accept & Continue"}
        </Button>
      </div>
    </div>
  );
}
